import apiHandler from "../core/apiHandler";

const purchaseDashboardApi = apiHandler('dashboard/purchases');
export default purchaseDashboardApi;
